import { useState } from "react";

import { Input } from "@chakra-ui/react";

type TextCellProps = {
  value: string | number | null;
  onSave?: (value: string) => void;
  type?: "text" | "number";
  placeholder?: string;
  nullable?: boolean;
};

// FIXME: Given `value` won't be modified, thus the shown value won't
// be updated after a save, showing our user stale data.
export const TextCell = ({
  value,
  onSave,
  type = "text",
  placeholder,
  nullable = false,
}: TextCellProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value?.toString() || "");

  // Reset inputValue when starting to edit
  const startEditing = () => {
    setInputValue(value?.toString() || "");
    setIsEditing(true);
  };

  const handleSave = () => {
    if (!onSave) return;
    if (nullable && inputValue.trim() === "") {
      onSave("");
    } else if (inputValue.trim() !== value?.toString()) {
      onSave(inputValue.trim());
    }
    setIsEditing(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      setInputValue(value?.toString() || "");
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <Input
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyPress}
        type={type}
        placeholder={placeholder}
        size="sm"
        autoFocus
      />
    );
  }

  return (
    <div
      onClick={onSave ? startEditing : undefined}
      style={{
        cursor: onSave ? "pointer" : "default",
        minHeight: "24px",
        padding: "2px",
        opacity: onSave ? 1 : 0.7,
      }}
    >
      {value || (nullable ? "-" : placeholder)}
    </div>
  );
};
